export enum ENV {
  MainnetBeta = 101,
  Testnet = 102,
  Devnet = 103,
}
